import cx from 'classnames';
import React from 'react';
import { View, ViewProps } from '../View/View';
import styles from './List.module.scss';

export interface ListProps<T> extends ViewProps<T> {
  listStyleType?:
    | 'disc'
    | 'circle'
    | 'square'
    | 'decimal'
    | 'georgian'
    | 'trad-chinese-informal'
    | 'kannada'
    | 'none';
}

const List = <T extends HTMLElement>({
  className,
  listStyleType,
  style,
  ...props
}: ListProps<T>) => {
  return (
    <View
      className={cx(
        styles.list,
        listStyleType === 'none' && styles.noListStyle,
        className
      )}
      style={{ listStyleType, ...style }}
      {...props}
    />
  );
};

export const OrderedList = <T extends HTMLOListElement>(props: ListProps<T>) => (
  <List as="ol" {...props} />
);

export const UnorderedList = <T extends HTMLUListElement>(props: ListProps<T>) => (
  <List as="ul" {...props} />
);

export const NumberList = <T extends HTMLUListElement>({
  className,
  ...props
}: ListProps<T>) => (
  <List as="ul" className={cx(styles.number, className)} {...props} />
);

export const DetailList = <T extends HTMLDListElement>(props: ListProps<T>) => (
  <View as="dl" {...props} />
);
